<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <p class="control is-expanded">
            <label class="label">Type</label>
            <select class="select is-fullwidth" v-model="contact.type" name="type" id="type" v-validate="'required'">
              <option value="1" v-if="parseInt(context.$store.state.config.user.level) === 3 && (chain_id)">Commecial Representative</option>
              <option value="2" v-if="parseInt(context.$store.state.config.user.level) === 3 && (chain_id || provider_id)">Immediate Responsible</option>
              <option value="3" v-if="parseInt(context.$store.state.config.user.level) === 3 && (chain_id)">Financial Officer</option>
              <option value="5" v-if="parseInt(context.$store.state.config.user.level) === 3 && (provider_id || agency_id)">Emergency</option>
              <option value="6" v-if="parseInt(context.$store.state.config.user.level) === 3 && (agency_id)">General</option>
              <option value="7" v-if="parseInt(context.$store.state.config.user.level) === 3 && (agency_id)">General Responsible</option>
              <option value="8" v-if="parseInt(context.$store.state.config.user.level) === 3 && (agency_id)">Parent Company</option>
              <option value="9" v-if="parseInt(context.$store.state.config.user.level) === 3 && (hotel_id)">Contact Payment</option>
              <option value="10" v-if="parseInt(context.$store.state.config.user.level) === 3 && (hotel_id)">Commercial</option>
              <option value="11" v-if="parseInt(context.$store.state.config.user.level) === 3 && (hotel_id)">Operation</option>
              <option value="4">Other</option>
            </select>
            <span v-show="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</span>
          </p>
          <p class="control" v-if="parseInt(contact.type) === 4">
            <label class="label">Other Name (Optional)</label>
            <input :class="{'input': true, 'is-danger': errors.has('other'), 'is-disabled': inProgress}" type="text" name="other" id="other" placeholder="Other" v-model="contact.other">
            <span v-show="errors.has('other')" class="help is-danger">{{ errors.first('other') }}</span>
          </p>
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Phone</label>
              <input :class="{'input': true, 'is-danger': errors.has('phone'), 'is-disabled': inProgress}" type="text" name="phone" id="phone" placeholder="Phone" v-model="contact.phone" v-validate="'required'">
              <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
            </p>
            <p class="control">
              <label class="label">Phone Extension</label>
              <input :class="{'input': true, 'is-danger': errors.has('phone_extension'), 'is-disabled': inProgress}" type="text" name="phone_extension" id="phone_extension" placeholder="Phone Extension" v-model="contact.phone_extension">
              <span v-show="errors.has('phone_extension')" class="help is-danger">{{ errors.first('phone_extension') }}</span>
            </p>
          </div>
          <p class="control is-expanded">
            <label class="label">E-Mail</label>
            <input :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="text" name="email" id="email" placeholder="E-Mail" v-model="contact.email" v-validate="'email'">
            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
          </p>
          <p class="control is-expanded">
            <label class="label">Responsible</label>
            <input :class="{'input': true, 'is-danger': errors.has('responsible'), 'is-disabled': inProgress}" type="text" name="responsible" id="responsible" placeholder="Responsible" v-model="contact.responsible">
            <span v-show="errors.has('responsible')" class="help is-danger">{{ errors.first('responsible') }}</span>
          </p>
        </div>
        <p class="control">
          <label class="label">Comment</label>
          <input :class="{'input': true, 'is-disabled': inProgress}" type="text" name="comment" id="comment" placeholder="" v-model="contact.comment">
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      parent: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      id: {
        type: Number
      },
      chain_id: {
        type: Number,
        default: null
      },
      provider_id: {
        type: Number,
        default: null
      },
      agency_id: {
        type: Number,
        default: null
      },
      hotel_id: {
        type: Number,
        default: null
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        contact: {
          chain_id: null,
          agency_id: null,
          base_id: null,
          provider_id: null,
          hotel_id: null,
          type: '',
          phone: '',
          phone_extension: '',
          email: '',
          responsible: '',
          other: ''
        },
        inProgress: false,
        stage: 1,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.edit) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      close (closeOnly) {
        if (!closeOnly) {
          this.parent[this.callback]()
        }
        this.$el.remove()
      },
      save () {
        this.$validator.validateAll().then(() => {
          this.inProgress = true
          this.error = ''
          this.contact.chain_id = this.chain_id
          this.contact.provider_id = this.provider_id
          this.contact.agency_id = this.agency_id
          this.contact.hotel_id = this.hotel_id
          if (!this.edit) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/contacts', this.contact).then((response) => {
              this.inProgress = false
              this.close(false)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/contacts/' + this.id, this.contact).then((response) => {
              this.inProgress = false
              this.close(false)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/contacts/' + this.id).then((response) => {
          this.contact = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      },
      checkType (type) {
        let exist = false
        this.parent.contacts.forEach(contact => {
          if (contact.type === type) {
            exist = true
          }
        })
        return exist
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?4c7fdb8f